.beancord {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  border-radius: 0;
  outline: 0;
  border: 0;
}